import momentTimezone from 'moment-timezone'

angular.module('app').constant('moment', momentTimezone);